<template>
    <div v-click-outside="closeMe" class="relative" @mouseleave="hovering = false" @mouseover="hovering = true">
        <div
            v-if="$slots.default || inputLabel"
            class="text-body-sm font-semibold flex items-center"
        >
            <span class="first-letter:uppercase text-black">
                <slot>{{ capitaliseFirst(inputLabel) }}</slot>
            </span>
            <span
                v-if="$slots.description"
                class="text-primary-80 text-body-sm"
            >
                <slot name="description"></slot>
            </span>
        </div>
        <div
            class="flex items-center justify-between w-full cursor-pointer rounded h-full"
            @click="toggleMe"
        >
            <slot name="trigger" :isOpen="showMe"></slot>
            <span v-if="withChevron" class="h-full">
                <svg-icon
                    :class="showMe ? 'rotate-180' : ''"
                    type="keyboard-arrow-down"
                />
            </span>
        </div>

        <transition name="slide-fade">
            <div
                v-if="activateOnHover ? hovering : showMe"
                :class="[ containerPositionX, containerPositionY, 'w-' + width ]"
                class="absolute z-60 flex flex-col bg-white shadow rounded mt-8 overflow-hidden"
            >
                    <slot :close="closeMe" name="content"></slot>
            </div>
        </transition>

    </div>
</template>

<script>
import clickOutside from '../../mixins/clickOutside';
import SvgIcon from "./SvgIcon.vue";
import {ucfirst} from "../../../shared/helpers";

export default {
    components: {SvgIcon},
    mixins: [
        clickOutside,
    ],
    props: {
        position: {
            type: String,
            validator: value => ['left', 'right', 'center', 'top', 'bottom'].includes(value),
            default: 'left',
        },
        width: {
            type: String,
            default: 'fit',
        },
        activateOnHover: {
            type: Boolean,
            default: false,
        },
        onTop: Boolean,
        withChevron: Boolean,
        inputLabel: String,
    },
    data: function () {
        return {
            showMe: false,
            hovering: false,
        };
    },
    computed: {
        containerPositionX() {
            switch (this.position) {
                case 'left':
                    return ['absolute', 'left-0', 'min-w-full'];
                case 'right':
                    return ['absolute', 'right-0'];
                case 'center':
                    return ['absolute', 'left-0', 'transform', '-translate-x-1/2'];
                case 'top':
                    return ['absolute', 'bottom-48 left-8'];
                case 'bottom':
                    return ['absolute', 'top-100'];
                default:
                    return [];
            }
        },
        containerPositionY() {
            if (this.onTop) {
                return 'bottom-full';
            }
        },
    },
    methods: {
        toggleMe() {
            this.showMe = !this.showMe;
        },
        openMe() {
            this.showMe = true;
        },
        closeMe() {
            this.showMe = false;
        },
        close() {
            this.closeMe();
        },
        capitaliseFirst(text = '') {
            return ucfirst(text);
        },
    },
    watch: {
        showMe(value) {
            if (value) {
                this.$emit('opened');
            } else {
                this.$emit('closed');
            }
        },
    },
};
</script>

<style scoped>
.slide-fade-enter-active {
    transition: all .3s ease;
}

.slide-fade-leave-active {
    transition: all .3s ease;
}

.slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
}

.slide-fade-enter {
    transform: translateY(-10px);
}

.slide-fade-leave-to {
    transform: translateY(10px);
}
</style>
